const CONST = {
  SYMBOL_EUR: '\u20AC',
  PRIMARY_COLOR: '#0084FF',
  EMPTY_MAP_PADDING_FACTOR: 0.035,
  // We are using maxWidth in all MediaQuery components, let's
  // -1 px to be consistent with CSS ranges
  SCREEN_XS: 480 - 1,
  SCREEN_SM: 768 - 1,
  SCREEN_MD: 992 - 1,
  SCREEN_LG: 120 - 1,
  MAP_MIN_ZOOM: 4,
  MAP_MAX_ZOOM: 19,
};

export default CONST;



// WEBPACK FOOTER //
// ./src/constants.js